
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 49"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"fill":"#D0EFEC","d":"M5.177 32.752h31l-15.5-27z"}}),_c('path',{staticClass:"i-triangle",attrs:{"stroke":"#234652","stroke-miterlimit":"10","d":"m14.634 21.717-.434.75H36.99l-.433-.75-10.528-18.22-.433-.748-.433.749z"}}),_c('path',{staticClass:"i-square",attrs:{"stroke":"#234652","stroke-miterlimit":"10","d":"M44.823 27.2H27.737v17.084h17.085z"}}),_c('circle',{staticClass:"i-circle",attrs:{"cx":"13.228","cy":"35.701","r":"9.551","stroke":"#234652"}})])
          )
        }
      }
    